import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./giftcitysection.css";

const cards = [
  {
    title: "SEZ",
    subtitle: "Special Economic Zone",
    color: "#d49c18",
    content:
      "Duty-free imports/exports, simplified regulatory clearances, CAPEX/OPEX incentives under Gujarat GCC Policy 2025–30.",
  },
  {
    title: "IFSC",
    subtitle: "Int'l Financial Services Centre",
    color: "#007f6e",
    content:
      "Treated as foreign jurisdiction under FEMA. Transactions in USD/EUR/GBP. Non-resident status for exchange control. No mainland India FX restrictions.",
  },
  {
    title: "Smart City",
    subtitle: "Greenfield Infrastructure",
    color: "#13294B",
    content:
      "Plug-and-play Grade A offices, district cooling, automated waste systems, underground utilities. Just minutes from Ahmedabad Airport.",
  },
];
const Giftcitysection = () => {
  return (
    <div>
      <section className="gift-city-section">
        <Container>
          {/* Heading */}

          <motion.div
            initial={{ opacity: 0, y: -40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center text-lg-start"
          >
            <p className="gift-label">WHAT IS GIFT CITY</p>

            <h2 className="gift-title">
              India's Offshore-on-Shore Jurisdiction
            </h2>

            <p className="gift-quote">
              "Onshore talent. Offshore regulatory and tax framework. Global
              scale."
            </p>
          </motion.div>

          {/* Cards */}

          <Row className="mt-5 g-4">
            {cards.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <motion.div
                  className="gift-card"
                  initial={{ opacity: 0, y: 70 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.6,
                    delay: index * 0.2,
                  }}
                  viewport={{ once: true }}
                  whileHover={{
                    y: -12,
                    scale: 1.02,
                  }}
                >
                  <div
                    className="top-line"
                    style={{ background: item.color }}
                  ></div>

                  <h2>{item.title}</h2>

                  <span>{item.subtitle}</span>

                  <p>{item.content}</p>
                </motion.div>
              </Col>
            ))}
          </Row>

          {/* Bottom Bar */}

          <motion.div
            className="bottom-info"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            viewport={{ once: true }}
          >
            Single Regulator: IFSCA &nbsp; | &nbsp; RBI + SEBI + IRDAI + PFRDA
            &nbsp; | &nbsp; Single-window clearance via SWIT Portal
          </motion.div>
        </Container>
      </section>
    </div>
  );
};

export default Giftcitysection;
